/**
 * Renderização segura de um subconjunto de Markdown nas bolhas do agente.
 *
 * Por quê: o agente (pilar-agent) responde em Markdown padrão (**negrito**,
 * links como URL crua) — é o formato comum que o LLM produz, e mantê-lo
 * agnóstico de canal é o que deixa o mesmo prompt/resposta servir WhatsApp e
 * widget (cada canal renderiza do seu jeito; WhatsApp tem sua própria sintaxe
 * de *negrito com um asterisco só*, diferente disso aqui). Sem essa função, a
 * bolha mostrava os `**` literais e uma URL crua não-clicável.
 *
 * NUNCA usa innerHTML com texto vindo do LLM — só createElement/textContent,
 * elemento por elemento. Mesmo sendo nosso próprio agente (não um terceiro
 * não confiável), uma resposta poderia em tese ecoar algo de um dado de tool
 * (descrição de imóvel) — tratar como não confiável custa zero e evita a
 * classe inteira de bug de HTML injection.
 */

const INLINE_TOKEN = /(\*\*[^*\n]+\*\*|https?:\/\/[^\s<>"']+)/g

function renderInline(container: HTMLElement, line: string): void {
  let lastIndex = 0
  for (const match of line.matchAll(INLINE_TOKEN)) {
    const index = match.index ?? 0
    if (index > lastIndex) {
      container.appendChild(document.createTextNode(line.slice(lastIndex, index)))
    }
    const token = match[0]
    if (token.startsWith('**')) {
      const strong = document.createElement('strong')
      strong.textContent = token.slice(2, -2)
      container.appendChild(strong)
    } else {
      const link = document.createElement('a')
      link.href = token
      link.textContent = token
      link.target = '_blank'
      link.rel = 'noopener noreferrer'
      container.appendChild(link)
    }
    lastIndex = index + token.length
  }
  if (lastIndex < line.length) {
    container.appendChild(document.createTextNode(line.slice(lastIndex)))
  }
}

/** Preenche `container` (a bolha) a partir de texto em Markdown, linha por linha. */
export function renderRichText(container: HTMLElement, text: string): void {
  const lines = text.split('\n')
  lines.forEach((line, index) => {
    if (line.trim() === '---') {
      container.appendChild(document.createElement('hr'))
      return
    }
    renderInline(container, line)
    if (index < lines.length - 1) {
      container.appendChild(document.createElement('br'))
    }
  })
}
